import { render, staticRenderFns } from "./league.vue?vue&type=template&id=d4f78fa4&scoped=true&"
import script from "./league.vue?vue&type=script&lang=js&"
export * from "./league.vue?vue&type=script&lang=js&"
import style0 from "./league.vue?vue&type=style&index=0&id=d4f78fa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f78fa4",
  null
  
)

export default component.exports